"use client";

import React from "react";
import AgreementBody from "@/components/store/AgreementBody";

export default function AgreementPage() {
  return (
    <div className="agreement-page">
      <header className="agreement-hero">
        <div className="agreement-hero-inner">
          <div>
            <h1 className="agreement-h1">Rental Agreement</h1>
            <p className="agreement-lead">Car rental terms &amp; conditions · ქართული / English</p>
          </div>
          <button type="button" onClick={() => window.print()} className="agreement-print">
            Print
          </button>
        </div>
      </header>

      <main className="agreement-main">
        <div className="agreement-card">
          <AgreementBody />
        </div>
      </main>

      <style jsx global>{`
        .agreement-page {
          min-height: 100vh;
          background: var(--sf-surface-2, #f2f4f7);
        }
        .agreement-hero {
          background: var(--sf-surface, #fff);
          border-bottom: 1px solid var(--sf-border, #e5e9ef);
        }
        .agreement-hero-inner {
          max-width: 1080px;
          margin: 0 auto;
          padding: 20px 20px;
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .agreement-h1 {
          margin: 0;
          font-size: 26px;
          font-weight: 800;
          letter-spacing: -0.01em;
          color: var(--sf-ink, #17202b);
        }
        .agreement-lead {
          margin: 4px 0 0;
          font-size: 14px;
          color: var(--sf-ink-3, #8a94a3);
        }
        .agreement-print {
          margin-left: auto;
          padding: 9px 16px;
          border: 1px solid var(--sf-border-strong, #cfd6df);
          border-radius: 10px;
          background: var(--sf-surface, #fff);
          color: var(--sf-ink-2, #495563);
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
        }
        .agreement-print:hover {
          background: var(--sf-surface-2, #f5f7fa);
        }
        .agreement-main {
          max-width: 1080px;
          margin: 0 auto;
          padding: 22px 20px 60px;
        }
        .agreement-card {
          background: var(--sf-surface, #fff);
          border: 1px solid var(--sf-border, #e5e9ef);
          border-radius: 16px;
          box-shadow: var(--sf-shadow, 0 1px 2px rgba(16, 24, 40, 0.05), 0 4px 16px rgba(16, 24, 40, 0.06));
          overflow: hidden;
        }
        @media print {
          .agreement-hero { display: none !important; }
          .agreement-page { background: #fff; }
          .agreement-main { padding: 0; max-width: none; }
          .agreement-card { border: none; box-shadow: none; border-radius: 0; }
          @page { size: auto; margin: 12mm; }
          html, body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      `}</style>
    </div>
  );
}
